import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './pages/Home.js';
import AboutUs from './pages/AboutUs.js'
import ContactUs from './pages/ContactUs.js'
import Services from './pages/Services';
import reportWebVitals from './reportWebVitals';
import Navbar from './components/navbar.js';
import Footer from './components/footer.js'
import {BrowserRouter, Routes, Route} from "react-router";
import {ParallaxProvider} from 'react-scroll-parallax'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ParallaxProvider>
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route path = "/" element = {<Home/>} />
          <Route path = "/Contact" element = {<ContactUs/>} />
          <Route path = "Contact/:prefillSubjectData" element = {<ContactUs/>} />
          <Route path = "/About" element = {<AboutUs/>} />
          <Route path = "/Services" element = {<Services/>} />

        </Routes>
        <Footer/>
      </BrowserRouter>
    </ParallaxProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
